module.exports = __webpack_public_path__ + "27a5988ed15ca88d9ca7f68e975b2b1a.svg";